<template>
  <div
    class="trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md"
  >
    <div class="trezo-card-content">
      <ul>
        <li
          class="border-b border-gray-100 dark:border-[#172036] mb-[20px] md:mb-[25px] pb-[20px] md:pb-[25px] ltr:pl-[20px] rtl:pr-[20px] ltr:md:pl-[25px] rtl:md:pr-[25px] ltr:first:pl-0 rtl:first:pr-0 first:border-primary-500 last:border-0 last:pb-0 last:mb-0"
        >
          <div class="sm:flex items-center gap-[15px] mb-[12px]">
            <div class="flex items-center">
              <img
                src="@/assets/images/users/user6.jpg"
                width="30"
                height="30"
                alt="user-image"
                class="rounded-full ltr:mr-[10px] rtl:ml-[10px]"
              />
              <span class="block font-medium text-primary-500"> Ponsiano </span>
            </div>
            <span class="block my-[10px] sm:my-0"> a day ago </span>
            <span
              class="inline-block bg-primary-500 text-white rounded-[4px] py-[2px] px-[8px] font-medium text-xs"
            >
              #BD0JL0G6
            </span>
          </div>
          <p>
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s, when an unknown printer took a galley of type
            and scrambled it to make a type specimen book. It has survived not
            only five centuries, but also the leap into electronic typesetting,
            remaining essentially unchanged.
          </p>
          <h6 class="text-[15px] mb-[12px]">Screenshots</h6>
          <div class="-mb-[15px]">
            <img
              src="@/assets/images/courses/course1.jpg"
              alt="screenshot-image"
              class="rounded-md inline-block w-[80px] ltr:mr-[10px] rtl:ml-[10px] mb-[15px] ltr:last:mr-0 rtl:last:ml-0"
            />
          </div>
        </li>
        <li
          class="border-b border-gray-100 dark:border-[#172036] mb-[20px] md:mb-[25px] pb-[20px] md:pb-[25px] ltr:pl-[20px] rtl:pr-[20px] ltr:md:pl-[25px] rtl:md:pr-[25px] ltr:first:pl-0 rtl:first:pr-0 first:border-primary-500 last:border-0 last:pb-0 last:mb-0"
        >
          <div class="sm:flex items-center gap-[15px] mb-[12px]">
            <div class="flex items-center">
              <img
                src="@/assets/images/users/user7.jpg"
                width="30"
                height="30"
                alt="user-image"
                class="rounded-full ltr:mr-[10px] rtl:ml-[10px]"
              />
              <span class="block font-medium text-danger-500"> Zelxa </span>
            </div>
            <span class="block my-[10px] sm:my-0"> 18 hours ago </span>
            <span
              class="inline-block bg-secondary-500 text-white rounded-[4px] py-[2px] px-[8px] font-medium text-xs"
            >
              Support Staff
            </span>
          </div>
          <p>
            It was popularised in the 1960s with the release of Letraset sheets
            containing Lorem Ipsum passages, and more recently with desktop
            publishing software like Aldus PageMaker including versions of Lorem
            Ipsum.
          </p>
          <h6 class="text-[15px] mb-[12px]">Screenshots</h6>
          <div class="-mb-[15px]">
            <img
              src="@/assets/images/products/product1.jpg"
              alt="screenshot-image"
              class="rounded-md inline-block w-[80px] ltr:mr-[10px] rtl:ml-[10px] mb-[15px] ltr:last:mr-0 rtl:last:ml-0"
            />
            <img
              src="@/assets/images/products/product2.jpg"
              alt="screenshot-image"
              class="rounded-md inline-block w-[80px] ltr:mr-[10px] rtl:ml-[10px] mb-[15px] ltr:last:mr-0 rtl:last:ml-0"
            />
          </div>
        </li>
        <li
          class="border-b border-gray-100 dark:border-[#172036] mb-[20px] md:mb-[25px] pb-[20px] md:pb-[25px] ltr:pl-[20px] rtl:pr-[20px] ltr:md:pl-[25px] rtl:md:pr-[25px] ltr:first:pl-0 rtl:first:pr-0 first:border-primary-500 last:border-0 last:pb-0 last:mb-0"
        >
          <div class="sm:flex items-center gap-[15px] mb-[12px]">
            <div class="flex items-center">
              <img
                src="@/assets/images/users/user6.jpg"
                width="30"
                height="30"
                alt="user-image"
                class="rounded-full ltr:mr-[10px] rtl:ml-[10px]"
              />
              <span class="block font-medium text-primary-500"> Ponsiano </span>
            </div>
            <span class="block my-[10px] sm:my-0"> 12 hours ago </span>
          </div>
          <p>
            It has survived not only five centuries, but also the leap into
            electronic typesetting, remaining essentially unchanged.
          </p>
        </li>
        <li
          class="border-b border-gray-100 dark:border-[#172036] mb-[20px] md:mb-[25px] pb-[20px] md:pb-[25px] ltr:pl-[20px] rtl:pr-[20px] ltr:md:pl-[25px] rtl:md:pr-[25px] ltr:first:pl-0 rtl:first:pr-0 first:border-primary-500 last:border-0 last:pb-0 last:mb-0"
        >
          <div class="sm:flex items-center gap-[15px] mb-[12px]">
            <div class="flex items-center">
              <img
                src="@/assets/images/users/user7.jpg"
                width="30"
                height="30"
                alt="user-image"
                class="rounded-full ltr:mr-[10px] rtl:ml-[10px]"
              />
              <span class="block font-medium text-danger-500"> Zelxa </span>
            </div>
            <span class="block my-[10px] sm:my-0"> 05 hours ago </span>
            <span
              class="inline-block bg-secondary-500 text-white rounded-[4px] py-[2px] px-[8px] font-medium text-xs"
            >
              Support Staff
            </span>
          </div>
          <p>
            The standard chunk of Lorem Ipsum used since the 1500s is reproduced
            below for those interested. Sections 1.10.32 and 1.10.33 from "de
            Finibus Bonorum et Malorum" by Cicero are also reproduced in their
            exact original form, accompanied by English versions from the 1914
            translation.
          </p>
        </li>
      </ul>
      <form class="mt-[20px] md:mt-[25px]">
        <label class="mb-[10px] text-black dark:text-white font-medium block">
          Post A Reply
        </label>
        <TextEditor />
        <div class="mt-[20px] md:mt-[25px]">
          <button
            type="button"
            class="font-medium inline-block transition-all rounded-md md:text-md py-[10px] md:py-[12px] px-[20px] md:px-[22px] bg-danger-500 text-white hover:bg-danger-400 ltr:mr-[15px] rtl:ml-[15px]"
          >
            Save As Draft
          </button>
          <button
            type="button"
            class="font-medium inline-block transition-all rounded-md md:text-md py-[10px] md:py-[12px] px-[20px] md:px-[22px] bg-primary-500 text-white hover:bg-primary-400"
          >
            <span class="inline-block relative ltr:pl-[29px] rtl:pr-[29px]">
              <i
                class="material-symbols-outlined ltr:left-0 rtl:right-0 absolute top-1/2 -translate-y-1/2"
              >
                send
              </i>
              Submit Now
            </span>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import TextEditor from "@/components/Common/TextEditor.vue";

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Comments",
  components: {
    TextEditor,
  },
});
</script>
